// Module importer

// Import modules
// JS imports
import Carousel from './Carousels';
import Tabs from './Tabs';
import Dropdown from './Dropdown';
import Swappable from './Swappable';
import Toggle from './Toggle';
import Truncate from './Truncate';
import Newsletters from './Newsletters';
import Notice from './Notice';
import svgAspectRatio from './svgAspectRatio';
import Autocomplete from './Autocomplete';
import SurpriseMe from './SurpriseMe';
import Events from './Events';
import LazyLoadTitles from './LazyLoadTitles';
import MailchimpPopup from './MailchimpPopup';
import VideoFormat from './VideoFormat';
import Print from './Print';
import CountdownClock from './CountdownClock';
import SwiperSlider from './SwiperSlider';
import BrazeHachette from './BrazeHachette';

// Init modules
function startModules() {
  window.hachette.manager.initComponent('notice', Notice);
  window.hachette.manager.initComponent('tabs', Tabs);
  window.hachette.manager.initComponent('carousel', Carousel);
  window.hachette.manager.initComponent('dropdown', Dropdown);
  window.hachette.manager.initComponent('swappable', Swappable);
  window.hachette.manager.initComponent('toggle', Toggle);
  window.hachette.manager.initComponent('truncate', Truncate);
  window.hachette.manager.initComponent('newsletters', Newsletters);
  window.hachette.manager.initComponent('svgAspectRatio', svgAspectRatio);
  window.hachette.manager.initComponent('autocomplete', Autocomplete);
  window.hachette.manager.initComponent('surpriseme', SurpriseMe);
  window.hachette.manager.initComponent('events', Events);
  window.hachette.manager.initComponent('lazyLoadTitles', LazyLoadTitles);
  window.hachette.manager.initComponent('mailchimpPopup', MailchimpPopup);
  window.hachette.manager.initComponent('videoFormat', VideoFormat);
  window.hachette.manager.initComponent('print', Print);
  window.hachette.manager.initComponent('countdownclock', CountdownClock);
  window.hachette.manager.initComponent('swiperSlider', SwiperSlider);
  window.hachette.manager.initComponent('brazeHachette', BrazeHachette);
}

export default startModules;
